import { useState, useEffect } from 'react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { decodeFileName } from '@/utils';

interface RenameDialogProps {
  currentName: string;
  onConfirm: (newName: string) => void;
  onCancel: () => void;
  isPending?: boolean;
}

export function RenameDialog({ currentName, onConfirm, onCancel, isPending }: RenameDialogProps) {
  const decodedName = decodeFileName(currentName);
  const [name, setName] = useState(decodedName);

  useEffect(() => {
    setName(decodedName);
  }, [decodedName]);

  const handleSubmit = () => {
    const trimmed = name.trim();
    if (trimmed && trimmed !== decodedName) {
      onConfirm(trimmed);
    } else if (trimmed === decodedName) {
      onCancel();
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50">
      <div className="bg-card border rounded-lg p-6 w-full max-w-md shadow-xl">
        <h2 className="text-lg font-semibold mb-4">重命名</h2>
        <Input
          value={name}
          onChange={(e) => setName(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === 'Enter') handleSubmit();
            if (e.key === 'Escape') onCancel();
          }}
          autoFocus
        />
        <div className="flex justify-end gap-2 mt-4">
          <Button variant="outline" onClick={onCancel}>
            取消
          </Button>
          <Button onClick={handleSubmit} disabled={isPending || !name.trim()}>
            {isPending ? '保存中...' : '确认'}
          </Button>
        </div>
      </div>
    </div>
  );
}
